import React, { useEffect, useRef, useState } from "react";
import style from "./thongTinBenhNhan.module.less";
import { Form, Row, Col, Input, notification, Button, Space, Spin, Popover } from "antd";
import i18n, { languageKeys } from "../../../../i18n";
import { Select } from "../../../../components";
import { useSelector } from "react-redux";
import { isEmptyObject, isValidBarcode, locdau } from "../../../../helpers";
import { apiSuaThongTinBN, apiThongTinChiTietBN } from "../../api/apiBenhNhan";
import { DrivingLicense, danhSachGioiTinh } from "../../../../constants/data";
import SearchTHX from "../../../QuanLyTiepDon/ModalTiepDon/components/SearchTHX";
import moment from "moment";
import { formatPatientData } from "pages/QuanLyTiepDon/hooksTiepDon";
import DateFormItem from "components_v2/DateInput/DateFormItem";
import { fieldTiepDon } from "pages/QuanLyTiepDon/fieldsTiepDon";
import { BarcodeOutlined } from "@ant-design/icons";

import Barcode from 'react-jsbarcode'
import { useEventListener } from "hooks";


const ThongTinBenhNhan = ({
  initData = {},
  onClose = () => {},
  doAfterSubmit = () => {},
  doneFetchDetailCustomer,
  setDoneFetchDetailCustomer = () => {},
  allowKeyboard,
  readOnly = false,
  isUseEventListener = true
}) => {

  const dateRef = useRef()

  const { quoc_gia, tinh, huyen, xa, nghe_nghiep, dan_toc } = useSelector((state) => state.data);

  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm()
  const MA_TINH_THANH = Form.useWatch("MA_TINH_THANH", form)
  const MA_QUAN_HUYEN = Form.useWatch("MA_QUAN_HUYEN", form)

  
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);

  const valueBarcodeKh = Form.useWatch("BARCODE_KHACH_HANG", form);
  const valueBarcode = useRef();

  const handleIconClick = (e) => {
    e.stopPropagation(); // Ngăn Popover đóng khi click icon
    valueBarcode.current = valueBarcodeKh || null; // Gán giá trị barcode
    setIsPopoverVisible(true); // Mở Popover
  };



  useEffect(() => {
    if (!isEmptyObject(initData) && !doneFetchDetailCustomer) layThongTinBenhNhan()
  }, [initData]);


  //api lấy thông tin bệnh nhân
  const layThongTinBenhNhan = async () => {
    setLoading(true)
    try {
      const res = await apiThongTinChiTietBN({ ID: initData?.ID, MA_BENH_NHAN: initData?.MA_BENH_NHAN });
      if (res) {
        if (res.status === 'OK') {
          const record = res.result
          form.setFields([
            ...Object.keys(record).map((item) => {
              if (item === "NGAY_SINH") {
                if (record?.NGAY_SINH?.length === 4) {
                  dateRef.current?.setDate(["", "", record.NGAY_SINH]);
                } else if (record?.NGAY_SINH?.length === 8) {
                  let date = moment(record.NGAY_SINH, "YYYYMMDD").format("DD/MM/YYYY");
                  dateRef.current?.setDate(date.split("/"));
                }
                return {
                  name: "NGAY_SINH",
                  value: moment(record.NGAY_SINH).format(record?.NGAY_SINH?.length === 4 ? "YYYY" : "DDMMYYYY")
                }
              } else {
                return { name: item, value: record[item] }
              }
            })
          ]);
          setDoneFetchDetailCustomer(true)
        } else {
          notification.error({ message: i18n.t(languageKeys.noti_Tai_du_lieu_that_bai), placement: 'bottomLeft' });
        }
      }
    } catch (e) {
      console.log(e)
      notification.error({ message: i18n.t(languageKeys.common_co_loi_xay_ra), placement: 'bottomLeft' });
    } finally {
      setLoading(false)
    }
  };


  // Sửa thông tin
  const handleSubmit = async () => {
    setLoading(true)
    try {
      const patientData = await formatPatientData(form.getFieldValue(undefined), false)
      const res = await apiSuaThongTinBN(patientData)
      if (res) {
        if (res.status === 'OK') {
          onClose()
          doAfterSubmit(res?.chi_tiet?.[0] || null)
          notification.success({ message: i18n.t(languageKeys.cap_nhat_thanh_cong), placement: 'bottomLeft' });
        } else {
          notification.error({ message: i18n.t(languageKeys.cap_nhat_that_bai), placement: 'bottomLeft' });
        }
      }
    } catch (e) {
      console.log(e)
      notification.error({ message: i18n.t(languageKeys.common_co_loi_xay_ra), placement: 'bottomLeft' });
    } finally {
      setLoading(false)
    }
  }


  // hàm xử lý phím tắt
  function keydownEvent(e) {
    if (e.ctrlKey && e.key === "s") {
      if(isUseEventListener){
      e.stopPropagation();
      e.preventDefault();
      form.submit();
    } 
  }
  }
  useEventListener("keydown", keydownEvent, window, allowKeyboard);


  return (
    <Spin spinning={loading}>
      <Form form={form} layout="vertical" className={style.form} onFinish={handleSubmit}>
        <h4>{i18n.t(languageKeys.field_Thong_tin_hanh_chinh)}</h4>
        <div className={style.wrapper}>
          <Row gutter={[10, 2]}>

            <Col span={4}>
              <Form.Item
                label={i18n.t(languageKeys.sdt)}
                name={"SO_DIEN_THOAI"}
                rules={[
                  {
                    required: true,
                    message: i18n.t(languageKeys.vui_long_nhap),
                  },
                  {
                    pattern: /(84|0[3|5|7|8|9])+([0-9]{8,9})\b/,
                    min: 10,
                    max: 11,
                    message: i18n.t(languageKeys.noti_vui_long_nhap_dung_dinh_dang) + " " + i18n.t(languageKeys.field_So_dien_thoai).toLowerCase(),
                  },
                ]}
              >
                <Input placeholder={i18n.t(languageKeys.common_Nhap)} readOnly={readOnly} />
              </Form.Item>
            </Col>

            <Col span={4}>
              <Form.Item
                label={i18n.t(languageKeys.ho_va_ten)}
                name={"TEN"}
                rules={[{
                  required: true,
                  message: i18n.t(languageKeys.vui_long_nhap),
                }]}
              >
                <Input
                  placeholder={i18n.t(languageKeys.common_Nhap)}
                  readOnly={readOnly}
                  onBlur={(e) => form.setFieldValue("TEN", e.target.value.toUpperCase())}
                />
              </Form.Item>
            </Col>

            <Col span={3}>
              <Form.Item
                label={i18n.t(languageKeys.field_Gioi_tinh)}
                name={"GIOI_TINH"}
                rules={[{
                  required: true,
                  message: i18n.t(languageKeys.vui_long_nhap),
                }]}
              >
                <Select
                  dataSource={danhSachGioiTinh}
                  valueKey='key'
                  titleKey='name'
                  readOnly={readOnly}
                  placeholder={i18n.t(languageKeys.common_Chon)}
                />
              </Form.Item>
            </Col>

            <Col span={4}>
              <DateFormItem
                label={i18n.t(languageKeys.field_Ngay_sinh)}
                name="NGAY_SINH"
                tabIndex={[4, 4, 3]}
                dateRef={dateRef}
                form={form}
                readOnly={readOnly}
              />
            </Col>

            <Col span={4}>
              <Form.Item
                label={i18n.t(languageKeys.CCCD_Passport)}
                name={"CCCD"}
                rules={[{
                  pattern: /^[0-9]*$/,
                  message: i18n.t(languageKeys.vui_long_nhap_dung_dinh_dang),
                }]}
              >
                <Input placeholder={i18n.t(languageKeys.common_Nhap)} readOnly={readOnly} />
              </Form.Item>
            </Col>

            <Col span={5}>
              <Form.Item
                name={"EMAIL"}
                label={i18n.t(languageKeys.field_Email)}
                rules={[{
                  pattern: /\S+@\S+\.\S+/,
                  message: i18n.t(languageKeys.vui_long_nhap_dung_dinh_dang),
                }]}
              >
                <Input placeholder={i18n.t(languageKeys.common_Nhap)} readOnly={readOnly} />
              </Form.Item>
            </Col>

            <Col span={4}>
              <SearchTHX
                form={form}
                onSelect={(record) => form.setFields([
                  { name: "MA_TINH_THANH", value: record.MA_TINH_THANH },
                  { name: "MA_QUAN_HUYEN", value: record.MA_QUAN_HUYEN },
                  { name: "MA_PHUONG_XA", value: record.MA_PHUONG_XA },
                  { name: "TEN_TINH_THANH", value: record.TEN_TINH_THANH },
                  { name: "TEN_QUAN_HUYEN", value: record.TEN_QUAN_HUYEN },
                  { name: "TEN_PHUONG_XA", value: record.TEN_PHUONG_XA },
                ])}
                readOnly={readOnly}
              />
            </Col>

            <Col span={4}>
              <Form.Item label={i18n.t(languageKeys.field_Tinh_thanh)} name={"MA_TINH_THANH"}>
                <Select
                  dataSource={tinh}
                  valueKey='MA_TINH_THANH'
                  titleKey='TEN_TINH_THANH'
                  showSearch
                  filterOption={(input, option) => locdau(option.children?.toString()).indexOf(input.toLowerCase()) >= 0}
                  allowClear
                  onChange={(_, { fullValue }) => {
                    form.setFieldValue("TEN_TINH_THANH", fullValue.TEN_TINH_THANH)
                    form.resetFields(["MA_PHUONG_XA", "MA_QUAN_HUYEN", "MA_KHU_VUC"])
                  }}
                  readOnly={readOnly}
                  placeholder={i18n.t(languageKeys.common_Chon)}
                />
              </Form.Item>
            </Col>

            <Col span={4}>
              <Form.Item label={i18n.t(languageKeys.field_Quan_huyen)} name={"MA_QUAN_HUYEN"}>
                <Select
                  dataSource={huyen[MA_TINH_THANH]}
                  showSearch
                  valueKey='MA_QUAN_HUYEN'
                  titleKey='TEN_QUAN_HUYEN'
                  filterOption={(input, option) => locdau(option.children?.toString()).indexOf(input.toLowerCase()) >= 0}
                  allowClear
                  onChange={(_, { fullValue }) => {
                    form.setFieldValue("TEN_QUAN_HUYEN", fullValue.TEN_QUAN_HUYEN)
                    form.resetFields(["MA_PHUONG_XA", "MA_KHU_VUC"])
                  }}
                  readOnly={readOnly}
                  placeholder={i18n.t(languageKeys.common_Chon)}
                />
              </Form.Item>
            </Col>

            <Col span={4}>
              <Form.Item label={i18n.t(languageKeys.field_Xa_phuong)} name={"MA_PHUONG_XA"}>
                <Select
                  dataSource={xa[MA_QUAN_HUYEN]}
                  valueKey='MA_PHUONG_XA'
                  titleKey='TEN_PHUONG_XA'
                  showSearch
                  filterOption={(input, option) => locdau(option.children?.toString()).indexOf(input.toLowerCase()) >= 0}
                  allowClear
                  readOnly={readOnly}
                  onChange={(_, { fullValue }) => form.setFields([
                    { name: "TEN_PHUONG_XA", value: fullValue?.TEN_PHUONG_XA },
                    { name: "MA_KHU_VUC", value: fullValue?.TEN_VIET_TAT },
                  ])}
                  placeholder={i18n.t(languageKeys.common_Chon)}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item label={i18n.t(languageKeys.field_Dia_chi_chi_tiet)} name={"DIA_CHI_CHI_TIET"}>
                <Input placeholder={i18n.t(languageKeys.common_Nhap)} readOnly={readOnly} />
              </Form.Item>
            </Col>

            <Col span={4}>
              <Form.Item label={i18n.t(languageKeys.field_Nghe_nghiep)} name={"MA_NGHE_NGHIEP"}>
                <Select
                  dataSource={nghe_nghiep}
                  valueKey='MA_NGHE_NGHIEP'
                  titleKey='TEN_NGHE_NGHIEP'
                  showSearch
                  filterOption={(input, option) => locdau(option.children?.toString()).indexOf(input.toLowerCase()) >= 0}
                  readOnly={readOnly}
                  onChange={(_, { fullValue }) => form.setFieldValue("NGHE_NGHIEP", fullValue.TEN_NGHE_NGHIEP)}
                />
              </Form.Item>
            </Col>

            <Col span={4}>
              <Form.Item label={i18n.t(languageKeys.field_Quoc_gia)} name={"MA_QUOC_TICH"}>
                <Select
                  dataSource={quoc_gia}
                  valueKey='MA_QUOC_GIA'
                  titleKey='TEN_QUOC_GIA'
                  showSearch
                  filterOption={(input, option) => locdau(option.children?.toString()).indexOf(input.toLowerCase()) >= 0}
                  readOnly={readOnly}
                  placeholder={i18n.t(languageKeys.common_Chon)}
                  onChange={(_, { fullValue }) => form.setFieldValue("QUOC_TICH", fullValue.TEN_QUOC_GIA)}
                />
              </Form.Item>
            </Col>

            <Col span={4}>
              <Form.Item label={i18n.t(languageKeys.field_Dan_toc)} name={"MA_DAN_TOC"}>
                <Select
                  dataSource={dan_toc}
                  valueKey='ID'
                  titleKey='DAN_TOC'
                  showSearch
                  filterOption={(input, option) => locdau(option.children?.toString()).indexOf(input.toLowerCase()) >= 0}
                  readOnly={readOnly}
                  onChange={(_, { fullValue }) => form.setFieldValue("DAN_TOC", fullValue.DAN_TOC)}
                />
              </Form.Item>
            </Col>

            <Col span={4}>
              <Form.Item label={i18n.t(languageKeys.hang_bang_lx)} name={"BANG_LAI_XE"}>
                <Select
                  dataSource={DrivingLicense.map(i => ({ title: i, value: i }))}
                  valueKey={'value'}
                  titleKey={'title'}
                  readOnly={readOnly}
                />
              </Form.Item>
            </Col>

            <Col span={4}>
            <Popover
                  open={isPopoverVisible}
                  content={() => {
                    return  <>
                    {isValidBarcode(valueBarcode?.current) ? (
                      <Barcode value={valueBarcode?.current || "123"} />
                    ) : (
                      <p style={{ color: "red" }}>Mã barcode không hợp lệ</p>
                    )}
                  </>
                  }}
                  title={false}
                  trigger="click"
                  onOpenChange={(visible) => setIsPopoverVisible(false)}
                  className={style["wrap-popover-input"]}
                >
                  <Form.Item
                    name={fieldTiepDon.BARCODE_KHACH_HANG}
                    label={i18n.t(languageKeys.field_barcode_kh)}
                    rules={[
                      {
                        pattern: /^[A-Za-z0-9\-_.]+$/,
                        message: "Chỉ cho phép chữ, số, dấu '-', '_' và '.'",
                      },
                    ]}

                  >
                    <Input tabIndex={6} placeholder={i18n.t(languageKeys.common_Nhap)} readOnly={readOnly} suffix={<BarcodeOutlined onClick={(e) => {
                      if (valueBarcodeKh?.length > 0 && isValidBarcode(valueBarcodeKh)) {
                        handleIconClick(e);
                      }

                    }} style={{ cursor: "pointer" }} />} />
                  </Form.Item>
                </Popover></Col>

          </Row>
        </div>

        <Row justify="end">
          <Space>
            <Button type="primary" ghost onClick={onClose}>
              {i18n.t(languageKeys.common_Thoat)} (ESC)
            </Button>
            <Button type="primary" disabled={readOnly} onClick={() => form.submit()}>
              {i18n.t(languageKeys.luu)}{isUseEventListener ?  '(Ctrl+S)' :''} 
            </Button>
          </Space>
        </Row>

      </Form>
    </Spin>

  );
};

export default ThongTinBenhNhan;